import type { EntitySummary } from '../types/entities';
import type { ExportEntry } from '../types/export';

export function chapterExportScenes(chapter: EntitySummary, entities: EntitySummary[]) {
  const ids = Array.isArray(chapter.fieldValues?.scenes) ? chapter.fieldValues.scenes : [];
  const byId = new Map(entities.map((entity) => [entity.id, entity]));
  return ids.flatMap((id) => {
    const entity = typeof id === 'string' ? byId.get(id) : undefined;
    return entity?.status === 'active' && entity.templateCategory === 'szene' ? [entity] : [];
  });
}

export function chapterExportOrder(left: EntitySummary, right: EntitySummary) {
  const number = (entity: EntitySummary) => {
    const value = entity.fieldValues?.chapter_number;
    return typeof value === 'number' || (typeof value === 'string' && value.trim())
      ? Number(value)
      : Number.MAX_SAFE_INTEGER;
  };
  const a = number(left);
  const b = number(right);
  return (
    (Number.isFinite(a) ? a : Number.MAX_SAFE_INTEGER) - (Number.isFinite(b) ? b : Number.MAX_SAFE_INTEGER) ||
    left.title.localeCompare(right.title, 'de-DE', { numeric: true, sensitivity: 'base' })
  );
}

export function expandedExportIds(entries: ExportEntry[], entities: EntitySummary[]) {
  const byId = new Map(entities.map((entity) => [entity.id, entity]));
  const ids = new Set<string>();
  for (const entry of entries) {
    const entity = byId.get(entry.entityId);
    if (!entity || entity.status !== 'active') continue;
    ids.add(entity.id);
    if (entity.templateCategory === 'kapitel') {
      for (const scene of chapterExportScenes(entity, entities))
        if (entry.sceneIds === undefined || entry.sceneIds.includes(scene.id)) ids.add(scene.id);
    }
  }
  return [...ids];
}

export function moveExportEntry(entries: ExportEntry[], sourceId: string, targetIndex: number) {
  const sourceIndex = entries.findIndex((entry) => entry.entityId === sourceId);
  if (sourceIndex < 0 || targetIndex < 0 || targetIndex >= entries.length) return entries;
  const result = [...entries];
  const [source] = result.splice(sourceIndex, 1);
  result.splice(targetIndex, 0, source!);
  return result;
}
